export enum Tenant {
    BRAZIL = 'rio-brazil.prod',
    BRAZIL_TEST = 'rio-brazil.test',
    SOUTHKOREA = 'rio-southkorea.prod',
    SOUTHKOREA_TEST = 'rio-southkorea.test',
    EUROPE = 'rio-eu.prod',
    EUROPE_TEST = 'rio-eu.test',
    SOUTH_AFRICA = 'rio-southafrica.prod',
    SOUTH_AFRICA_TEST = 'rio-southafrica.test',
}

export const ALL_TENANTS = [
    Tenant.BRAZIL,
    Tenant.BRAZIL_TEST,
    Tenant.SOUTHKOREA,
    Tenant.SOUTHKOREA_TEST,
    Tenant.EUROPE,
    Tenant.EUROPE_TEST,
    Tenant.SOUTH_AFRICA,
    Tenant.SOUTH_AFRICA_TEST,
] as const;

export const EUROPE_TENANTS = [Tenant.EUROPE, Tenant.EUROPE_TEST] as const;

export const NON_EU_TENANTS = [
    Tenant.BRAZIL,
    Tenant.BRAZIL_TEST,
    Tenant.SOUTHKOREA,
    Tenant.SOUTHKOREA_TEST,
    Tenant.SOUTH_AFRICA,
    Tenant.SOUTH_AFRICA_TEST,
] as const;
